module.exports = __webpack_public_path__ + "assets/img/star_sentence_un5.34f80c44.png";